import {Component, HostListener, OnInit} from '@angular/core';
import {UIRouter} from "@uirouter/angular";
import {AuthenticationService} from "../core";
import {RemoteAccess} from "../models";

const trustedOrigins = ['http://localhost:4200', 'https://alarms.emodul.eu', 'https://moduly.emodul.eu'];
const allowedOpeners = ['http://localhost:4200', 'https://alarms.emodul.eu', 'https://moduly.emodul.eu'];

@Component({
    selector: 'remote-login',
    templateUrl: './remote-login.component.html',
    styleUrls: ['./remote-login.component.scss']
})
export class RemoteLoginComponent implements OnInit {
    constructor(
        private authentication: AuthenticationService,
        private router: UIRouter,
    ) {
    }

    ngOnInit() {
        const openerIndex = parseInt(this.router.globals.params['openerIndex'], 10);
        const isIndexValid = !Number.isNaN(openerIndex);
        if (!isIndexValid) {
            return;
        }

        let url = allowedOpeners[openerIndex];
        if (this.authentication.isAuthenticated() === true) {
            this.authentication.remoteLogout();
            this.sendPostMessage(url);

        } else {
            this.sendPostMessage(url);
        }
    }

    sendPostMessage(targetUrl: string) {
        const targetWindow = window.opener;
        targetWindow.postMessage({pageReady: true}, targetUrl);
    }

    @HostListener('window:message', ['$event'])
    onPostMessage(message: MessageEvent) {
        if (!message.data) {
            return;
        }
        if (!message.origin || !trustedOrigins.includes(message.origin)) {
            console.warn('Message from untrusted origin rejected:', message.origin);
            return;
        }

        let messageData: RemoteAccess;
        if (typeof message.data === 'string') {
            let parsed: unknown;
            try {
                parsed = JSON.parse(message.data);
            } catch (e: unknown) {
                console.error('Failed to parse message data:', e, 'Raw data:', message.data);
                return;
            }
            if (!this.isValidRemoteAccess(parsed)) {
                console.error('Invalid message data shape after parsing:', parsed);
                return;
            }
            messageData = parsed;
        } else if (typeof message.data === 'object') {
            if (!this.isValidRemoteAccess(message.data)) {
                console.error('Invalid message data shape:', message.data);
                return;
            }
            messageData = message.data;
        } else {
            console.error('Unexpected message data type:', typeof message.data);
            return;
        }
        this.authentication.username = messageData.username;
        this.authentication.restApiHash = messageData.restApiHash;
        this.authentication.remote = messageData.remote;
        this.authentication.login();
    }

    private isValidRemoteAccess(data: unknown): data is RemoteAccess {
        if (typeof data !== 'object' || data === null) {
            return false;
        }
        const obj = data as Record<string, unknown>;
        return obj['remote'] === true
            && typeof obj['restApiHash'] === 'string' && obj['restApiHash'].length > 0
            && typeof obj['username'] === 'string' && obj['username'].length > 0;
    }
}
